module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAiCAYAAAD7wEFuAAAACXBIWXMAABcRAAAXEQHKJvM/AAAA60lEQVRYhe2XsQ3CMBQFLxGVG2ihyghsACNQuAcmICNkBTaAGiQYATYJjWtSkNYUhg1sffnLJ7m/05eLV3nvGa+LJbBBB72x7gRQfS7zDXCT9YnO01i3roFW2iQBK4Aa6GU9kjAATAiXm/2eFlqAynsvLZKMWlogJSUuV0pcrpS4XFEdNwEYr4sGaERNImKse4DeVXA21u20roIthD/3FhZJwQAhrgWesi5RGSirIHNKXK6UuFwpcbmiOu6/CmbAUtglFr2xroewCtbAHZhKGkXmaKxra6BDVxjAAfSuAiDEdcBL2CM2e1C+Cr7+xTWhn5Q9dgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/component/header/images/icon_burgerMenu3.png
// module id = 357
// module chunks = 4